module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "grid-x grid-margin-x"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "small-12 cell"
  }, [_c('div', {
    staticClass: "callout large"
  }, [_c('h5', [_vm._v("Looking for a sneaker?")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.searchResults))]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    attrs: {
      "type": "text",
      "list": "sneakers",
      "required": ""
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.filteredSneaker != undefined) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.filteredSneaker), function(sneaker) {
    return _c('option', {
      domProps: {
        "value": sneaker
      }
    }, [_vm._v(_vm._s(sneaker.model_name))])
  })) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.goToSneaker()
      }
    }
  }, [_vm._v("Go to sneaker")])])])]), _vm._v(" "), _vm._l((_vm.brands), function(brand) {
    return _c('div', {
      staticClass: "small-12 medium-6 large-4 cell"
    }, [_c('router-link', {
      staticClass: "card",
      attrs: {
        "to": {
          path: ("/sneakers/" + (brand.name))
        }
      }
    }, [_c('img', {
      attrs: {
        "src": brand.hero_image_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-section"
    }, [_c('p', {
      staticClass: "lead"
    }, [_vm._v(_vm._s(brand.name))])])])], 1)
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small-12 cell text-center"
  }, [_c('h1', [_vm._v("Sneakers")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a56c17dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Sneakers.vue
// module id = 76
// module chunks = 0